(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["event-code-gate"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-event-code-form]').forEach((form) => {
    if (form.dataset.eventCodeReady === 'true') return;
    form.dataset.eventCodeReady = 'true';

    const input = form.querySelector('input[name="event_code"]');
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-event-code-error]');
    const defaultErrorText = error.textContent;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const enteredCode = input.value.trim().toUpperCase();
      const destinations = [
        {
          code: 'MMS26',
          name: 'Mermaid Color Studio',
          url: 'https://mermaid.itsdagifts.com/',
        },
        {
          code: 'MO26',
          name: "Missouri — She's From",
          url: 'https://states.itsdagifts.com/MO',
        },
        {
          code: form.dataset.eventCodeOne,
          name: form.dataset.eventNameOne,
          url: form.dataset.collectionUrlOne,
        },
        {
          code: form.dataset.eventCodeTwo,
          name: form.dataset.eventNameTwo,
          url: form.dataset.collectionUrlTwo,
        },
        {
          code: form.dataset.eventCodeThree,
          name: form.dataset.eventNameThree,
          url: form.dataset.collectionUrlThree,
        },
        {
          code: form.dataset.eventCodeFour,
          name: form.dataset.eventNameFour,
          url: form.dataset.collectionUrlFour,
        },
      ].filter((destination) => destination.code && destination.url);
      const destination = destinations.find((item) => item.code === enteredCode);

      if (!enteredCode || !destination) {
        input.setAttribute('aria-invalid', 'true');
        error.hidden = false;
        input.focus();
        return;
      }

      input.removeAttribute('aria-invalid');
      error.hidden = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          credentials: 'same-origin',
        });
        if (!cartResponse.ok) throw new Error('The cart could not be checked.');
        const cart = await cartResponse.json();
        const existingCode = String(cart.attributes?.['Event Code'] || '').trim().toUpperCase();

        if (cart.item_count > 0 && existingCode !== destination.code) {
          const shouldSwitch = window.confirm(
            `Your cart belongs to another event. Start ${destination.name} and clear that cart?`,
          );
          if (!shouldSwitch) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
            return;
          }

          const clearResponse = await fetch(`${root}cart/clear.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
          });
          if (!clearResponse.ok) throw new Error('The prior event cart could not be cleared.');
        }

        const destinationUrl = new URL(destination.url, window.location.origin).toString();
        const updateResponse = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Event Code': destination.code,
              'Event Shop': destination.name,
              'Event Storefront': destination.code,
              'Event Storefront Host': new URL(destinationUrl).host,
              'Event Return URL': destinationUrl,
            },
          }),
        });
        if (!updateResponse.ok) throw new Error('The event cart could not be started.');
      } catch (error) {
        console.warn('The event code could not be added to the cart before redirecting.', error);
        button.disabled = false;
        button.removeAttribute('aria-busy');
        error.textContent = 'Your event cart could not be opened. Please try again.';
        error.hidden = false;
        return;
      }

      window.location.assign(destination.url);
    });

    input.addEventListener('input', () => {
      input.removeAttribute('aria-invalid');
      error.textContent = defaultErrorText;
      error.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
